export enum Colors {
  'BLACK' = 'black',
  'WHITE' = 'white',
  'TRANSPARENT' = 'transparent',
  'CURRENT' = 'current',
  'RUBY.25' = 'ruby.25',
  'RUBY.50' = 'ruby.50',
  'RUBY.100' = 'ruby.100',
  'RUBY.200' = 'ruby.200',
  'RUBY.300' = 'ruby.300',
  'RUBY.400' = 'ruby.400',
  'RUBY.500' = 'ruby.500',
  'RUBY.600' = 'ruby.600',
  'RUBY.700' = 'ruby.700',
  'RUBY.800' = 'ruby.800',
  'RUBY.900' = 'ruby.900',
  'RUBY.950' = 'ruby.950',
  'RUBY.975' = 'ruby.975',
  'RED.25' = 'red.25',
  'RED.50' = 'red.50',
  'RED.100' = 'red.100',
  'RED.200' = 'red.200',
  'RED.300' = 'red.300',
  'RED.400' = 'red.400',
  'RED.500' = 'red.500',
  'RED.600' = 'red.600',
  'RED.700' = 'red.700',
  'RED.800' = 'red.800',
  'RED.900' = 'red.900',
  'RED.950' = 'red.950',
  'RED.975' = 'red.975',
  'ORANGE.25' = 'orange.25',
  'ORANGE.50' = 'orange.50',
  'ORANGE.100' = 'orange.100',
  'ORANGE.200' = 'orange.200',
  'ORANGE.300' = 'orange.300',
  'ORANGE.400' = 'orange.400',
  'ORANGE.500' = 'orange.500',
  'ORANGE.600' = 'orange.600',
  'ORANGE.700' = 'orange.700',
  'ORANGE.800' = 'orange.800',
  'ORANGE.900' = 'orange.900',
  'ORANGE.950' = 'orange.950',
  'ORANGE.975' = 'orange.975',
  'YELLOW.25' = 'yellow.25',
  'YELLOW.50' = 'yellow.50',
  'YELLOW.100' = 'yellow.100',
  'YELLOW.200' = 'yellow.200',
  'YELLOW.300' = 'yellow.300',
  'YELLOW.400' = 'yellow.400',
  'YELLOW.500' = 'yellow.500',
  'YELLOW.600' = 'yellow.600',
  'YELLOW.700' = 'yellow.700',
  'YELLOW.800' = 'yellow.800',
  'YELLOW.900' = 'yellow.900',
  'YELLOW.950' = 'yellow.950',
  'YELLOW.975' = 'yellow.975',
  'GOLD.25' = 'gold.25',
  'GOLD.50' = 'gold.50',
  'GOLD.100' = 'gold.100',
  'GOLD.200' = 'gold.200',
  'GOLD.300' = 'gold.300',
  'GOLD.400' = 'gold.400',
  'GOLD.500' = 'gold.500',
  'GOLD.600' = 'gold.600',
  'GOLD.700' = 'gold.700',
  'GOLD.800' = 'gold.800',
  'GOLD.900' = 'gold.900',
  'GOLD.950' = 'gold.950',
  'GOLD.975' = 'gold.975',
  'LIME.25' = 'lime.25',
  'LIME.50' = 'lime.50',
  'LIME.100' = 'lime.100',
  'LIME.200' = 'lime.200',
  'LIME.300' = 'lime.300',
  'LIME.400' = 'lime.400',
  'LIME.500' = 'lime.500',
  'LIME.600' = 'lime.600',
  'LIME.700' = 'lime.700',
  'LIME.800' = 'lime.800',
  'LIME.900' = 'lime.900',
  'LIME.950' = 'lime.950',
  'LIME.975' = 'lime.975',
  'GREEN.25' = 'green.25',
  'GREEN.50' = 'green.50',
  'GREEN.100' = 'green.100',
  'GREEN.200' = 'green.200',
  'GREEN.300' = 'green.300',
  'GREEN.400' = 'green.400',
  'GREEN.500' = 'green.500',
  'GREEN.600' = 'green.600',
  'GREEN.700' = 'green.700',
  'GREEN.800' = 'green.800',
  'GREEN.900' = 'green.900',
  'GREEN.950' = 'green.950',
  'GREEN.975' = 'green.975',
  'JADE.25' = 'jade.25',
  'JADE.50' = 'jade.50',
  'JADE.100' = 'jade.100',
  'JADE.200' = 'jade.200',
  'JADE.300' = 'jade.300',
  'JADE.400' = 'jade.400',
  'JADE.500' = 'jade.500',
  'JADE.600' = 'jade.600',
  'JADE.700' = 'jade.700',
  'JADE.800' = 'jade.800',
  'JADE.900' = 'jade.900',
  'JADE.950' = 'jade.950',
  'JADE.975' = 'jade.975',
  'TEAL.25' = 'teal.25',
  'TEAL.50' = 'teal.50',
  'TEAL.100' = 'teal.100',
  'TEAL.200' = 'teal.200',
  'TEAL.300' = 'teal.300',
  'TEAL.400' = 'teal.400',
  'TEAL.500' = 'teal.500',
  'TEAL.600' = 'teal.600',
  'TEAL.700' = 'teal.700',
  'TEAL.800' = 'teal.800',
  'TEAL.900' = 'teal.900',
  'TEAL.950' = 'teal.950',
  'TEAL.975' = 'teal.975',
  'CYAN.25' = 'cyan.25',
  'CYAN.50' = 'cyan.50',
  'CYAN.100' = 'cyan.100',
  'CYAN.200' = 'cyan.200',
  'CYAN.300' = 'cyan.300',
  'CYAN.400' = 'cyan.400',
  'CYAN.500' = 'cyan.500',
  'CYAN.600' = 'cyan.600',
  'CYAN.700' = 'cyan.700',
  'CYAN.800' = 'cyan.800',
  'CYAN.900' = 'cyan.900',
  'CYAN.950' = 'cyan.950',
  'CYAN.975' = 'cyan.975',
  'BLUE.25' = 'blue.25',
  'BLUE.50' = 'blue.50',
  'BLUE.100' = 'blue.100',
  'BLUE.200' = 'blue.200',
  'BLUE.300' = 'blue.300',
  'BLUE.400' = 'blue.400',
  'BLUE.500' = 'blue.500',
  'BLUE.600' = 'blue.600',
  'BLUE.700' = 'blue.700',
  'BLUE.800' = 'blue.800',
  'BLUE.900' = 'blue.900',
  'BLUE.950' = 'blue.950',
  'BLUE.975' = 'blue.975',
  'NAVY.25' = 'navy.25',
  'NAVY.50' = 'navy.50',
  'NAVY.100' = 'navy.100',
  'NAVY.200' = 'navy.200',
  'NAVY.300' = 'navy.300',
  'NAVY.400' = 'navy.400',
  'NAVY.500' = 'navy.500',
  'NAVY.600' = 'navy.600',
  'NAVY.700' = 'navy.700',
  'NAVY.800' = 'navy.800',
  'NAVY.900' = 'navy.900',
  'NAVY.950' = 'navy.950',
  'NAVY.975' = 'navy.975',
  'INDIGO.25' = 'indigo.25',
  'INDIGO.50' = 'indigo.50',
  'INDIGO.100' = 'indigo.100',
  'INDIGO.200' = 'indigo.200',
  'INDIGO.300' = 'indigo.300',
  'INDIGO.400' = 'indigo.400',
  'INDIGO.500' = 'indigo.500',
  'INDIGO.600' = 'indigo.600',
  'INDIGO.700' = 'indigo.700',
  'INDIGO.800' = 'indigo.800',
  'INDIGO.900' = 'indigo.900',
  'INDIGO.950' = 'indigo.950',
  'INDIGO.975' = 'indigo.975',
  'VIOLET.25' = 'violet.25',
  'VIOLET.50' = 'violet.50',
  'VIOLET.100' = 'violet.100',
  'VIOLET.200' = 'violet.200',
  'VIOLET.300' = 'violet.300',
  'VIOLET.400' = 'violet.400',
  'VIOLET.500' = 'violet.500',
  'VIOLET.600' = 'violet.600',
  'VIOLET.700' = 'violet.700',
  'VIOLET.800' = 'violet.800',
  'VIOLET.900' = 'violet.900',
  'VIOLET.950' = 'violet.950',
  'VIOLET.975' = 'violet.975',
  'PURPLE.25' = 'purple.25',
  'PURPLE.50' = 'purple.50',
  'PURPLE.100' = 'purple.100',
  'PURPLE.200' = 'purple.200',
  'PURPLE.300' = 'purple.300',
  'PURPLE.400' = 'purple.400',
  'PURPLE.500' = 'purple.500',
  'PURPLE.600' = 'purple.600',
  'PURPLE.700' = 'purple.700',
  'PURPLE.800' = 'purple.800',
  'PURPLE.900' = 'purple.900',
  'PURPLE.950' = 'purple.950',
  'PURPLE.975' = 'purple.975',
  'MAGENTA.25' = 'magenta.25',
  'MAGENTA.50' = 'magenta.50',
  'MAGENTA.100' = 'magenta.100',
  'MAGENTA.200' = 'magenta.200',
  'MAGENTA.300' = 'magenta.300',
  'MAGENTA.400' = 'magenta.400',
  'MAGENTA.500' = 'magenta.500',
  'MAGENTA.600' = 'magenta.600',
  'MAGENTA.700' = 'magenta.700',
  'MAGENTA.800' = 'magenta.800',
  'MAGENTA.900' = 'magenta.900',
  'MAGENTA.950' = 'magenta.950',
  'MAGENTA.975' = 'magenta.975',
  'PINK.25' = 'pink.25',
  'PINK.50' = 'pink.50',
  'PINK.100' = 'pink.100',
  'PINK.200' = 'pink.200',
  'PINK.300' = 'pink.300',
  'PINK.400' = 'pink.400',
  'PINK.500' = 'pink.500',
  'PINK.600' = 'pink.600',
  'PINK.700' = 'pink.700',
  'PINK.800' = 'pink.800',
  'PINK.900' = 'pink.900',
  'PINK.950' = 'pink.950',
  'PINK.975' = 'pink.975',
  'BLACKOPAQUE.25' = 'blackOpaque.25',
  'BLACKOPAQUE.50' = 'blackOpaque.50',
  'BLACKOPAQUE.75' = 'blackOpaque.75',
  'BLACKOPAQUE.100' = 'blackOpaque.100',
  'BLACKOPAQUE.200' = 'blackOpaque.200',
  'BLACKOPAQUE.300' = 'blackOpaque.300',
  'BLACKOPAQUE.400' = 'blackOpaque.400',
  'BLACKOPAQUE.500' = 'blackOpaque.500',
  'BLACKOPAQUE.600' = 'blackOpaque.600',
  'BLACKOPAQUE.700' = 'blackOpaque.700',
  'BLACKOPAQUE.800' = 'blackOpaque.800',
  'BLACKOPAQUE.900' = 'blackOpaque.900',
  'BLACKOPAQUE.950' = 'blackOpaque.950',
  'BLACKOPAQUE.975' = 'blackOpaque.975',
  'BLACKOPAQUE.1000' = 'blackOpaque.1000',
  'BLACKALPHA.25' = 'blackAlpha.25',
  'BLACKALPHA.50' = 'blackAlpha.50',
  'BLACKALPHA.75' = 'blackAlpha.75',
  'BLACKALPHA.100' = 'blackAlpha.100',
  'BLACKALPHA.200' = 'blackAlpha.200',
  'BLACKALPHA.300' = 'blackAlpha.300',
  'BLACKALPHA.400' = 'blackAlpha.400',
  'BLACKALPHA.500' = 'blackAlpha.500',
  'BLACKALPHA.600' = 'blackAlpha.600',
  'BLACKALPHA.700' = 'blackAlpha.700',
  'BLACKALPHA.800' = 'blackAlpha.800',
  'BLACKALPHA.900' = 'blackAlpha.900',
  'BLACKALPHA.950' = 'blackAlpha.950',
  'BLACKALPHA.975' = 'blackAlpha.975',
  'WHITEALPHA.25' = 'whiteAlpha.25',
  'WHITEALPHA.50' = 'whiteAlpha.50',
  'WHITEALPHA.75' = 'whiteAlpha.75',
  'WHITEALPHA.100' = 'whiteAlpha.100',
  'WHITEALPHA.200' = 'whiteAlpha.200',
  'WHITEALPHA.300' = 'whiteAlpha.300',
  'WHITEALPHA.400' = 'whiteAlpha.400',
  'WHITEALPHA.500' = 'whiteAlpha.500',
  'WHITEALPHA.600' = 'whiteAlpha.600',
  'WHITEALPHA.700' = 'whiteAlpha.700',
  'WHITEALPHA.800' = 'whiteAlpha.800',
  'WHITEALPHA.900' = 'whiteAlpha.900',
  'WHITEALPHA.950' = 'whiteAlpha.950',
  'WHITEALPHA.975' = 'whiteAlpha.975',
  'GRAY.25' = 'gray.25',
  'GRAY.50' = 'gray.50',
  'GRAY.75' = 'gray.75',
  'GRAY.100' = 'gray.100',
  'GRAY.200' = 'gray.200',
  'GRAY.300' = 'gray.300',
  'GRAY.400' = 'gray.400',
  'GRAY.500' = 'gray.500',
  'GRAY.600' = 'gray.600',
  'GRAY.700' = 'gray.700',
  'GRAY.800' = 'gray.800',
  'GRAY.900' = 'gray.900',
  'GRAY.950' = 'gray.950',
  'GRAY.975' = 'gray.975',
  'GRAYALPHA.25' = 'grayAlpha.25',
  'GRAYALPHA.50' = 'grayAlpha.50',
  'GRAYALPHA.75' = 'grayAlpha.75',
  'GRAYALPHA.100' = 'grayAlpha.100',
  'GRAYALPHA.200' = 'grayAlpha.200',
  'GRAYALPHA.300' = 'grayAlpha.300',
  'GRAYALPHA.400' = 'grayAlpha.400',
  'GRAYALPHA.500' = 'grayAlpha.500',
  'GRAYALPHA.600' = 'grayAlpha.600',
  'GRAYALPHA.700' = 'grayAlpha.700',
  'GRAYALPHA.800' = 'grayAlpha.800',
  'GRAYALPHA.900' = 'grayAlpha.900',
  'GRAYALPHA.950' = 'grayAlpha.950',
  'GRAYALPHA.975' = 'grayAlpha.975',
  'ZINC.25' = 'zinc.25',
  'ZINC.50' = 'zinc.50',
  'ZINC.75' = 'zinc.75',
  'ZINC.100' = 'zinc.100',
  'ZINC.200' = 'zinc.200',
  'ZINC.300' = 'zinc.300',
  'ZINC.400' = 'zinc.400',
  'ZINC.500' = 'zinc.500',
  'ZINC.600' = 'zinc.600',
  'ZINC.700' = 'zinc.700',
  'ZINC.800' = 'zinc.800',
  'ZINC.900' = 'zinc.900',
  'ZINC.950' = 'zinc.950',
  'ZINC.975' = 'zinc.975',
  'ASH.25' = 'ash.25',
  'ASH.50' = 'ash.50',
  'ASH.75' = 'ash.75',
  'ASH.100' = 'ash.100',
  'ASH.200' = 'ash.200',
  'ASH.300' = 'ash.300',
  'ASH.400' = 'ash.400',
  'ASH.500' = 'ash.500',
  'ASH.600' = 'ash.600',
  'ASH.700' = 'ash.700',
  'ASH.800' = 'ash.800',
  'ASH.900' = 'ash.900',
  'ASH.950' = 'ash.950',
  'ASH.975' = 'ash.975',
  'SAGE.25' = 'sage.25',
  'SAGE.50' = 'sage.50',
  'SAGE.75' = 'sage.75',
  'SAGE.100' = 'sage.100',
  'SAGE.200' = 'sage.200',
  'SAGE.300' = 'sage.300',
  'SAGE.400' = 'sage.400',
  'SAGE.500' = 'sage.500',
  'SAGE.600' = 'sage.600',
  'SAGE.700' = 'sage.700',
  'SAGE.800' = 'sage.800',
  'SAGE.900' = 'sage.900',
  'SAGE.950' = 'sage.950',
  'SAGE.975' = 'sage.975',
  'SAND.25' = 'sand.25',
  'SAND.50' = 'sand.50',
  'SAND.75' = 'sand.75',
  'SAND.100' = 'sand.100',
  'SAND.200' = 'sand.200',
  'SAND.300' = 'sand.300',
  'SAND.400' = 'sand.400',
  'SAND.500' = 'sand.500',
  'SAND.600' = 'sand.600',
  'SAND.700' = 'sand.700',
  'SAND.800' = 'sand.800',
  'SAND.900' = 'sand.900',
  'SAND.950' = 'sand.950',
  'SAND.975' = 'sand.975',
  'PLUM.25' = 'plum.25',
  'PLUM.50' = 'plum.50',
  'PLUM.75' = 'plum.75',
  'PLUM.100' = 'plum.100',
  'PLUM.200' = 'plum.200',
  'PLUM.300' = 'plum.300',
  'PLUM.400' = 'plum.400',
  'PLUM.500' = 'plum.500',
  'PLUM.600' = 'plum.600',
  'PLUM.700' = 'plum.700',
  'PLUM.800' = 'plum.800',
  'PLUM.900' = 'plum.900',
  'PLUM.950' = 'plum.950',
  'PLUM.975' = 'plum.975',
  'STEEL.25' = 'steel.25',
  'STEEL.50' = 'steel.50',
  'STEEL.75' = 'steel.75',
  'STEEL.100' = 'steel.100',
  'STEEL.200' = 'steel.200',
  'STEEL.300' = 'steel.300',
  'STEEL.400' = 'steel.400',
  'STEEL.500' = 'steel.500',
  'STEEL.600' = 'steel.600',
  'STEEL.700' = 'steel.700',
  'STEEL.800' = 'steel.800',
  'STEEL.900' = 'steel.900',
  'STEEL.950' = 'steel.950',
  'STEEL.975' = 'steel.975',
  'CHAKRA_BODY_TEXT' = 'chakra-body-text',
  'CHAKRA_BODY_BG' = 'chakra-body-bg',
  'CHAKRA_BORDER_COLOR' = 'chakra-border-color',
  'CHAKRA_SUBTLE_BG' = 'chakra-subtle-bg',
  'CHAKRA_PLACEHOLDER_COLOR' = 'chakra-placeholder-color',
  'BORDER_DEFAULT' = 'border-default',
  'BORDER_SUBDUED' = 'border-subdued',
  'BORDER_MUTED' = 'border-muted',
  'BORDER_INPUT' = 'border-input',
  'BORDER_EMPHASIS' = 'border-emphasis',
  'BORDER_ELEVATED' = 'border-elevated',
  'BORDER_INVERT' = 'border-invert',
  'BORDER_FOCUS' = 'border-focus',
  'BORDER_FOCUS_SECONDARY' = 'border-focus-secondary',
  'BORDER_BRAND' = 'border-brand',
  'BORDER_NEUTRAL' = 'border-neutral',
  'BORDER_INFO' = 'border-info',
  'BORDER_SUCCESS' = 'border-success',
  'BORDER_WARNING' = 'border-warning',
  'BORDER_ERROR' = 'border-error',
  'BORDER_HIGHLIGHT' = 'border-highlight',
  'SURFACE_PAGE' = 'surface-page',
  'SURFACE_INSET' = 'surface-inset',
  'SURFACE_HOVER' = 'surface-hover',
  'SURFACE_ACTIVE' = 'surface-active',
  'SURFACE_INVERT' = 'surface-invert',
  'TEXT_EMPHASIS' = 'text-emphasis',
  'TEXT_EMPHASIS_INVERT' = 'text-emphasis-invert',
  'TEXT_MUTED' = 'text-muted',
  'TEXT_MUTED_INVERT' = 'text-muted-invert',
  'TEXT_SUBDUED' = 'text-subdued',
  'TEXT_SUBDUED_INVERT' = 'text-subdued-invert',
  'TEXT_PLACEHOLDER' = 'text-placeholder',
  'TEXT_BRAND' = 'text-brand',
  'TEXT_BRAND_HOVER' = 'text-brand-hover',
  'TEXT_BRAND_ACTIVE' = 'text-brand-active',
  'TEXT_BRAND_INVERT' = 'text-brand-invert',
  'TEXT_BRAND_INVERT_HOVER' = 'text-brand-invert-hover',
  'TEXT_BRAND_INVERT_ACTIVE' = 'text-brand-invert-active',
  'TEXT_INTERACTIVE' = 'text-interactive',
  'TEXT_INTERACTIVE_HOVER' = 'text-interactive-hover',
  'TEXT_INTERACTIVE_ACTIVE' = 'text-interactive-active',
  'TEXT_INTERACTIVE_INVERT' = 'text-interactive-invert',
  'TEXT_INTERACTIVE_INVERT_HOVER' = 'text-interactive-invert-hover',
  'TEXT_INTERACTIVE_INVERT_ACTIVE' = 'text-interactive-invert-active',
  'TEXT_ERROR' = 'text-error',
  'TEXT_ERROR_HOVER' = 'text-error-hover',
  'TEXT_ERROR_INVERT' = 'text-error-invert',
  'TEXT_INFO' = 'text-info',
  'TEXT_INFO_HOVER' = 'text-info-hover',
  'TEXT_INFO_INVERT' = 'text-info-invert',
  'TEXT_WARNING' = 'text-warning',
  'TEXT_WARNING_HOVER' = 'text-warning-hover',
  'TEXT_WARNING_INVERT' = 'text-warning-invert',
  'TEXT_SUCCESS' = 'text-success',
  'TEXT_SUCCESS_HOVER' = 'text-success-hover',
  'TEXT_SUCCESS_INVERT' = 'text-success-invert',
  'SURFACE_SUCCESS' = 'surface-success',
  'SURFACE_SUCCESS_SUBDUED' = 'surface-success-subdued',
  'SURFACE_WARNING' = 'surface-warning',
  'SURFACE_WARNING_SUBDUED' = 'surface-warning-subdued',
  'SURFACE_ERROR' = 'surface-error',
  'SURFACE_ERROR_SUBDUED' = 'surface-error-subdued',
  'SURFACE_INFO' = 'surface-info',
  'SURFACE_INFO_SUBDUED' = 'surface-info-subdued',
  'SURFACE_NEUTRAL' = 'surface-neutral',
  'SURFACE_NEUTRAL_ACCENT' = 'surface-neutral-accent',
  'SURFACE_NEUTRAL_MUTED' = 'surface-neutral-muted',
  'SURFACE_NEUTRAL_SUBDUED' = 'surface-neutral-subdued',
  'SURFACE_BRAND' = 'surface-brand',
  'SURFACE_BRAND_ACCENT' = 'surface-brand-accent',
  'SURFACE_BRAND_MUTED' = 'surface-brand-muted',
  'SURFACE_BRAND_SUBDUED' = 'surface-brand-subdued',
  'TEXT_ON_BRAND' = 'text-on-brand',
  'SURFACE_HIGHLIGHT' = 'surface-highlight',
  'SURFACE_HIGHLIGHT_ACCENT' = 'surface-highlight-accent',
  'SURFACE_HIGHLIGHT_MUTED' = 'surface-highlight-muted',
  'SURFACE_HIGHLIGHT_SUBDUED' = 'surface-highlight-subdued',
  'TEXT_ON_HIGHLIGHT' = 'text-on-highlight',
  'TEXT_HIGHLIGHT' = 'text-highlight',
  'TEXT_HIGHLIGHT_EMPHASIS' = 'text-highlight-emphasis',
  'TEXT_ON_SUCCESS' = 'text-on-success',
  'TEXT_ON_WARNING' = 'text-on-warning',
  'TEXT_ON_INFO' = 'text-on-info',
  'SURFACE_DISABLED' = 'surface-disabled',
  'SURFACE_SELECTED' = 'surface-selected',
  'TEXT_DISABLED' = 'text-disabled',
  'SURFACE_PRIMARY' = 'surface-primary',
  'SURFACE_PRIMARY_HOVER' = 'surface-primary-hover',
  'SURFACE_PRIMARY_ACTIVE' = 'surface-primary-active',
  'SURFACE_SECONDARY' = 'surface-secondary',
  'SURFACE_SECONDARY_HOVER' = 'surface-secondary-hover',
  'SURFACE_SECONDARY_ACTIVE' = 'surface-secondary-active',
  'SURFACE_TERTIARY' = 'surface-tertiary',
  'SURFACE_TERTIARY_HOVER' = 'surface-tertiary-hover',
  'SURFACE_TERTIARY_ACTIVE' = 'surface-tertiary-active',
  'SURFACE_TERTIARY_INVERT' = 'surface-tertiary-invert',
  'SURFACE_TERTIARY_INVERT_HOVER' = 'surface-tertiary-invert-hover',
  'SURFACE_TERTIARY_INVERT_ACTIVE' = 'surface-tertiary-invert-active',
  'SURFACE_ELEVATED' = 'surface-elevated',
  'SURFACE_ELEVATED_HOVER' = 'surface-elevated-hover',
  'SURFACE_ELEVATED_ACTIVE' = 'surface-elevated-active',
  'SURFACE_ELEVATED_INVERT' = 'surface-elevated-invert',
  'SURFACE_DIALOG' = 'surface-dialog',
  'SURFACE_DIALOG_HOVER' = 'surface-dialog-hover',
  'SURFACE_DIALOG_ACTIVE' = 'surface-dialog-active',
  'TEXT_ON_PRIMARY' = 'text-on-primary',
  'TEXT_ON_PRIMARY_HOVER' = 'text-on-primary-hover',
  'TEXT_ON_PRIMARY_ACTIVE' = 'text-on-primary-active',
  'TEXT_ON_SECONDARY' = 'text-on-secondary',
  'TEXT_ON_SECONDARY_HOVER' = 'text-on-secondary-hover',
  'TEXT_ON_SECONDARY_ACTIVE' = 'text-on-secondary-active',
  'SURFACE_WARNING_ACCENT' = 'surface-warning-accent',
  'SURFACE_WARNING_MUTED' = 'surface-warning-muted',
  'SURFACE_ERROR_ACCENT' = 'surface-error-accent',
  'SURFACE_ERROR_MUTED' = 'surface-error-muted',
  'SURFACE_INFO_ACCENT' = 'surface-info-accent',
  'SURFACE_INFO_MUTED' = 'surface-info-muted',
  'SURFACE_SUCCESS_ACCENT' = 'surface-success-accent',
  'SURFACE_SUCCESS_MUTED' = 'surface-success-muted',
  'TEXT_ON_ERROR' = 'text-on-error',
  'ICON_DEFAULT' = 'icon-default',
  'ICON_HOVER' = 'icon-hover',
  'ICON_ACTIVE' = 'icon-active',
  'ICON_NEUTRAL' = 'icon-neutral',
  'ICON_BRAND' = 'icon-brand',
  'ICON_BRAND_SELECTED' = 'icon-brand-selected',
  'ICON_SUCCESS' = 'icon-success',
  'ICON_ERROR' = 'icon-error',
  'ICON_INFO' = 'icon-info',
  'ICON_HIGHLIGHT' = 'icon-highlight',
  'ICON_WARNING' = 'icon-warning',
  'NEUTRAL.25' = 'neutral.25',
  'NEUTRAL.50' = 'neutral.50',
  'NEUTRAL.75' = 'neutral.75',
  'NEUTRAL.100' = 'neutral.100',
  'NEUTRAL.200' = 'neutral.200',
  'NEUTRAL.300' = 'neutral.300',
  'NEUTRAL.400' = 'neutral.400',
  'NEUTRAL.500' = 'neutral.500',
  'NEUTRAL.600' = 'neutral.600',
  'NEUTRAL.700' = 'neutral.700',
  'NEUTRAL.800' = 'neutral.800',
  'NEUTRAL.900' = 'neutral.900',
  'NEUTRAL.950' = 'neutral.950',
  'NEUTRAL.975' = 'neutral.975',
  'ERROR.25' = 'error.25',
  'ERROR.50' = 'error.50',
  'ERROR.100' = 'error.100',
  'ERROR.200' = 'error.200',
  'ERROR.300' = 'error.300',
  'ERROR.400' = 'error.400',
  'ERROR.500' = 'error.500',
  'ERROR.600' = 'error.600',
  'ERROR.700' = 'error.700',
  'ERROR.800' = 'error.800',
  'ERROR.900' = 'error.900',
  'ERROR.950' = 'error.950',
  'ERROR.975' = 'error.975',
  'WARNING.25' = 'warning.25',
  'WARNING.50' = 'warning.50',
  'WARNING.100' = 'warning.100',
  'WARNING.200' = 'warning.200',
  'WARNING.300' = 'warning.300',
  'WARNING.400' = 'warning.400',
  'WARNING.500' = 'warning.500',
  'WARNING.600' = 'warning.600',
  'WARNING.700' = 'warning.700',
  'WARNING.800' = 'warning.800',
  'WARNING.900' = 'warning.900',
  'WARNING.950' = 'warning.950',
  'WARNING.975' = 'warning.975',
  'SUCCESS.25' = 'success.25',
  'SUCCESS.50' = 'success.50',
  'SUCCESS.100' = 'success.100',
  'SUCCESS.200' = 'success.200',
  'SUCCESS.300' = 'success.300',
  'SUCCESS.400' = 'success.400',
  'SUCCESS.500' = 'success.500',
  'SUCCESS.600' = 'success.600',
  'SUCCESS.700' = 'success.700',
  'SUCCESS.800' = 'success.800',
  'SUCCESS.900' = 'success.900',
  'SUCCESS.950' = 'success.950',
  'SUCCESS.975' = 'success.975',
  'BRAND.25' = 'brand.25',
  'BRAND.50' = 'brand.50',
  'BRAND.100' = 'brand.100',
  'BRAND.200' = 'brand.200',
  'BRAND.300' = 'brand.300',
  'BRAND.400' = 'brand.400',
  'BRAND.500' = 'brand.500',
  'BRAND.600' = 'brand.600',
  'BRAND.700' = 'brand.700',
  'BRAND.800' = 'brand.800',
  'BRAND.900' = 'brand.900',
  'BRAND.950' = 'brand.950',
  'BRAND.975' = 'brand.975',
  'INFO.25' = 'info.25',
  'INFO.50' = 'info.50',
  'INFO.100' = 'info.100',
  'INFO.200' = 'info.200',
  'INFO.300' = 'info.300',
  'INFO.400' = 'info.400',
  'INFO.500' = 'info.500',
  'INFO.600' = 'info.600',
  'INFO.700' = 'info.700',
  'INFO.800' = 'info.800',
  'INFO.900' = 'info.900',
  'INFO.950' = 'info.950',
  'INFO.975' = 'info.975',
  'HIGHLIGHT.25' = 'highlight.25',
  'HIGHLIGHT.50' = 'highlight.50',
  'HIGHLIGHT.100' = 'highlight.100',
  'HIGHLIGHT.200' = 'highlight.200',
  'HIGHLIGHT.300' = 'highlight.300',
  'HIGHLIGHT.400' = 'highlight.400',
  'HIGHLIGHT.500' = 'highlight.500',
  'HIGHLIGHT.600' = 'highlight.600',
  'HIGHLIGHT.700' = 'highlight.700',
  'HIGHLIGHT.800' = 'highlight.800',
  'HIGHLIGHT.900' = 'highlight.900',
  'HIGHLIGHT.950' = 'highlight.950',
  'HIGHLIGHT.975' = 'highlight.975',
}
